import html2canvas from 'html2canvas'

import { delay } from '@/packages/utils/debug'

export async function getQrImage() {
    const element = document.getElementById('qr-share')
    if (!element)
        return {
            file: null,
            blob: null,
        }

    element.style.visibility = 'visible'

    const canvas = await html2canvas(element)
    const imgData = canvas.toDataURL('image/png')
    const response = await fetch(imgData)
    const blob = await response.blob()
    const file = new File([blob], 'qr.png', {
        type: blob.type,
        lastModified: Date.now(),
    })
    element.style.visibility = 'hidden'

    await delay(500)

    return {
        file,
        blob,
    }
}
